module.exports = __webpack_public_path__ + "img/地枫皮.5f568804.jpg";